import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreCardComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Router , RouterModule } from '@angular/router';
import { PolicyDataService } from '../../../../../_services/data-services/policy-data.service';
import { Component, OnInit } from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreCardComponent, MapfreButtonComponent],
  selector: 'app-myinsurance-leakbot',
  templateUrl: './myinsurance-leakbot.component.html',
  styleUrls: ['./myinsurance-leakbot.component.scss'],
})
export class MyinsuranceLeakbotComponent implements OnInit {
  policyList: any;
  show = false;

  constructor(
    private policyDataService: PolicyDataService,
    public router: Router
  ) {}

  ngOnInit() {
    this.policyDataService.$policyDetails.subscribe((policyResponse: any) => {
      if (policyResponse) {
        policyResponse.forEach((policy) => {
          if (
            (policy.policyStatus == 'ACTIVE' ||
              (policy.policyStatus == 'FUTURE' && policy.isConverted)) &&
            !policy.policyCancellationReason &&
            (policy.policySubType == 'HO3' ||
              policy.policySubType == 'HO5' ||
              policy.policySubType == 'DP3')
          ) {
            this.show = true;
          }
        });
      }
    });
  }

  openLeakbot() {
    window.open(
      'https://myleakbot.com/mapfre-us/?sku=GBAA0030&voucher=MAPAAUSSST1-V1CJ-C1001&utm_source=CustomerPortal&utm_medium=Banner&utm_campaign=Pilot&utm_id=LeakBot',
      '_blank'
    );
  }
}
